import { cn } from "@gettactic/helpers";

/** A three-column grid of meeting attendees (one column on phones). */
export const MeetingUserGrid = ({
  children,
  classNames
}: {
  children: React.ReactNode;
  classNames?: string;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col md:grid w-full grid-cols-3 gap-2",
        classNames
      )}
    >
      {children}
    </div>
  );
};
